export enum AlarmCode {
    WSA = 'WSA',
    MBA = 'MBA',
    TURB = 'TURB',
}

export interface IOPointRoute {
    service: string,
    station: string,
    group: string,
    variable: string,
}
